import { FormattedMessage } from 'react-intl';
import style from './availability.module.scss';
import { useProductContext } from './productResultContext';

export const ProductResultAvailability = () => {
    const { result } = useProductContext();

    const messageInfo = result.stockAvailability
        ? {
              id: 'stock_availability',
              defaultMessage: 'Skladem',
              cn: style.stockAvailabilityTrue,
          }
        : {
              id: 'stock_no_availability',
              defaultMessage: 'Nedostupné',
              cn: style.stockAvailabilityFalse,
          };

    return (
        <div
            role="paragraph"
            className={`${style.productStock} ${messageInfo.cn}`}
            data-testid="product-result-stockavailability"
        >
            <FormattedMessage id={messageInfo.id} defaultMessage={messageInfo.defaultMessage} />
        </div>
    );
};
